exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "my-profile-page .tabTitles{padding:0 1em;display:flex}my-profile-page .tabTitles a{position:relative;text-decoration:none;flex:1;padding:.7em .5em;background:#ececec}my-profile-page .tabTitles a.active{background-color:#262625;color:#fff}my-profile-page .tabTitles a.active:before{position:absolute;bottom:-10px;left:calc(50% + -13px);content:\"\";width:0;height:0;border-style:solid;border-width:10px 13px 0;border-color:#262625 transparent transparent}@media (max-width:420px){.userName{width:300px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/profile/my-profile/my-profile.styl
// module id = 976
// module chunks = 0